/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum QuoteStopVerb {
    ASAP = 1,
    DeliverDirect = 2,
    Protect = 3,
    Open = 4,
    Close = 5,
    ReadyNow = 6,
    Hot = 7,
    Window = 8,
}
